import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { graphql } from "react-apollo"
import { useShowSuccessToast, Spacer } from "gatsby-interface"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { CheckoutForm, PaymentProvider } from "@modules/payment"
import { paymentInformation as text } from "@modules/locales/default.js"
import { UPDATE_PAYMENT_INFO } from "@modules/payment/queries"

let CheckoutFormWithMutation = CheckoutForm

if (graphql) {
  CheckoutFormWithMutation = graphql(UPDATE_PAYMENT_INFO)(
    CheckoutFormWithMutation
  )
}

export function UpdatePaymentForm({
  organizationId,
  id,
  setResponse = null,
  cancelCallback,
  className = ``,
}) {
  const showSuccessToast = useShowSuccessToast()
  const [setError, errorAlert] = useTriggerErrorAlert()

  return (
    <Fragment>
      <PaymentProvider>
        <CheckoutFormWithMutation
          checkoutType="UPDATE_PAYMENT"
          cancelCallback={cancelCallback}
          submitButtonText={text.updatePayment}
          cancelButtonText={text.cancelText}
          planId={id}
          organizationId={organizationId}
          className={className}
          showSuccess={creditCard => {
            setResponse &&
              setResponse({
                success: true,
                creditCard,
              })
            showSuccessToast(
              <React.Fragment>
                <strong>{text.paymentInformation}</strong>
                {` `}
                {text.updatedSuccessfully}
              </React.Fragment>
            )
            cancelCallback()
          }}
          showError={message => setError({ message })}
        >
          {errorAlert && (
            <React.Fragment>
              <Spacer size={8} />
              {errorAlert}
            </React.Fragment>
          )}
        </CheckoutFormWithMutation>
      </PaymentProvider>
    </Fragment>
  )
}

UpdatePaymentForm.propTypes = {
  name: PropTypes.string,
  organizationId: PropTypes.string,
  planId: PropTypes.string,
  setMessage: PropTypes.func,
  cancelCallback: PropTypes.func,
}
